/**
 * Animated skeleton placeholder for a repository card.
 *
 * Used in Showcase while data is loading to prevent layout shift
 * and provide perceived performance feedback.
 */
export function SkeletonCard() {
  return (
    <div
      className="rounded-xl border border-border bg-bg-card p-5 animate-pulse"
      aria-hidden="true"
    >
      {/* Header row — avatar + name */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 rounded-full bg-bg-surface shrink-0" />
        <div className="h-4 w-32 rounded bg-bg-surface" />
      </div>

      {/* Description lines */}
      <div className="space-y-2 mb-4">
        <div className="h-3 w-full rounded bg-bg-surface" />
        <div className="h-3 w-4/5 rounded bg-bg-surface" />
        <div className="h-3 w-3/5 rounded bg-bg-surface" />
      </div>

      {/* Tags row */}
      <div className="flex gap-2 mb-4">
        <div className="h-5 w-16 rounded-full bg-bg-surface" />
        <div className="h-5 w-20 rounded-full bg-bg-surface" />
        <div className="h-5 w-12 rounded-full bg-bg-surface" />
      </div>

      {/* Footer stats */}
      <div className="flex items-center gap-4 pt-3 border-t border-border">
        <div className="h-3 w-10 rounded bg-bg-surface" />
        <div className="h-3 w-10 rounded bg-bg-surface" />
        <div className="h-3 w-12 rounded bg-bg-surface ml-auto" />
      </div>
    </div>
  );
}

/** Render `count` skeleton cards in a responsive grid. */
export function SkeletonGrid({ count = 9 }: { count?: number }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
